const ONE_HOUR_IN_SECONDS = 60 * 60;

export default function prepareTimestampStrFromNumber(
  videoDuration: number,
  seconds: number
) {
  return formatTimestamp(seconds, videoDuration >= ONE_HOUR_IN_SECONDS);
}

// helper function to prepare timestamp string from a number of seconds in format HH:MM:SS
function formatTimestamp(
  seconds: number,
  isMoreThanHour: boolean = false
): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (isMoreThanHour) {
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }

  return `${minutes.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
}
